<template>
  <div>
    <el-row>
      <el-col :span="6">
        <el-form :model="form" :rules="form.rules" ref="form">
          <el-form-item label="Email *" prop="email">
            <el-input v-model="form.email" clearable type="email"></el-input>
          </el-form-item>
          <el-form-item label="Пароль *" prop="password">
            <el-input v-model="form.password" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="login('form');" plain type="success">Войти в аккаунт</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="$router.push({name: 'SignUp'});" plain type="primary">Создать аккаунт</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button @click.prevent="fakeUserLogin();" plain>Тестовый профиль</el-button>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button @click.prevent="signInAnonymously()" plain>Анонимно</el-button>
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <p>Ещё не имеете аккаунта? Вы можете <router-link to="/sign-up">создать его</router-link>.</p>
    <!-- <p>Так же вы можете воспользоваться <a href="#" @click.prevent="fakeUserLogin();">тестовым профилем</a>, без создания личного профиля, чтобы просмотреть текущие возможности приложения. Тестовый профиль аналогичен личному, однако Ваши настройки и рецепты не сохранятся после окончании сессии приложения.</p> -->
  </div>
</template>

<script>
  // import firebase from 'firebase';
  import {db} from '../firebase.js';
  import firebase from 'firebase/app';
  require('firebase/auth');
  export default {
    data() {
      return {
        form:{
          email: '',
          password: '',
          rules: {
            email: [
              {type: 'email', message: 'Проверьте адрес электронной почты', trigger: 'blur',},
              {required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
            ],
            password: [
              {required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
              {min: 6, message: 'Минимальная длина пароля должна быть 6 символов', trigger: 'blur'},
            ],
          },
        },
      }
    },
    mounted() {
      var self = this;
      // console.log(self.$route.params);
      if (self.$route.params.method == 'fakeUserLogin') {
        self.fakeUserLogin('expressPreview');
        /*self.$router.push({
          name: 'Import items', 
          params: {
            method: 'setPowerCraftSettings',
          },
        });*/
        // console.log('на страницу импорта');
      };
      self.$store.subscribe((mutation, state) => {
          switch(mutation.type) {
            case 'updateUser':
              if (self.$route.params.prevPage) {
                self.$router.push({name: self.$route.params.prevPage});
              };
            break;
          };
      });
    },
    methods: {
    	signIn(querySnapshot){
    		var self = this; 
            var oldUser = self.$store.state.user;
	        db.collection('users').doc(self.$store.state.user.uid).get().then(doc=>{
          		var data = {basket: true};
	          	// doc.ref.delete().then(function(){
          		doc.ref.update(data).then(function(){
	            	/*self.$store.state.user.delete().then(function() {
	              		self.$notify({title: 'Успех', message: 'Профиль успешно удалён', type: 'success'});
	              		// document.location.reload(true);
	        		}).catch(function(error) {
	        		});*/	          	 
		            firebase.auth().signInWithEmailAndPassword(self.form.email, self.form.password).then(
		              	(user) => {
		                	var user = user.user;
		                	self.$store.commit('updateUser', {user});
		                	self.$notify({title: 'Успех', message: 'Приветствую, Вы успешно вошли в аккаунт', type: 'success'});
		                	var size = querySnapshot.size;
		                	doc.ref.delete().then(function(){
		                		if (size != 0) {
				                	querySnapshot.forEach(function(doc){
				                		doc.ref.delete().then(function(){
				                			size--;
				                			if (size == 0) {
				                				oldUser.delete().then(function(){
					                				self.$router.push({name: 'profile'});	
					                				document.location.reload(true);
				                				});
				                			};
				                		});
				                	});
				                } else {
				                	oldUser.delete().then(function(){
		                				self.$router.push({name: 'profile'});
		                				document.location.reload(true);                					
	                				});
				                };
		                	});
		              	},
		              	(err) => {
		                	self.$notify({title: 'Ошибка', message: 'Ошибка: ' + err.message, type: 'error'});
	                		data = {basket: false};
		                	querySnapshot.forEach(function(doc){
		                		doc.ref.update(data);
		                	});
		                	doc.ref.update(data);
		              	},
		            ); 
	          	});
	        });		
    	},
      login: function(formName, nextPage) {
        var self = this;
        // var nextPage = nextPage || {name: 'profile'};
        this.$refs[formName].validate((valid) => {
          if (valid) {
            db.collectionGroup('recipes').where("author", "==", self.$store.state.user.uid).get().then(function(querySnapshot){
	            var size = querySnapshot.size;
	            if (size != 0) {
	              	querySnapshot.forEach(function(doc){
	              		var data = {basket: true};
	              		doc.ref.update(data).then(function(){
	                  		size--;
	                  		if (size == 0) {
	                  			self.signIn(querySnapshot);
	                		};
	              		});
	                });
	            } else {
	            	self.signIn(querySnapshot);
	            };        
	        });
          } else {
            self.$notify({title: 'Ошибка', message: 'Ошибка валидации формы', type: 'error'});
            return false;
          };
        });
      }, 
      removeUserDoc(){
        /*var self = this;
        db.collection('users').doc(self.$store.state.user.uid).get().then(doc=>{
          doc.ref.delete().then(function(){
            self.$store.state.user.delete().then(function() {
              self.$notify({title: 'Успех', message: 'Профиль успешно удалён', type: 'success'});
              document.location.reload(true);
            }).catch(function(error) {
            });
          });
        });*/
      },
      removeProfile(user){
        var self = this;
        // var profileName = (self.$store.state.user.isAnonymous == true) ? 'профиль' : 'аккаунт';
        // var consent = (consent) ? consent : confirm('Вы уверены что хотите удалить ' + profileName + '?');
        // if (consent) {
          /*db.collectionGroup('recipes').where("author", "==", self.$store.state.user.uid).get().then(function(querySnapshot){
            var size = querySnapshot.size;
            if (size != 0) {
              querySnapshot.forEach(function(doc){
                doc.ref.delete().then(function(){
                  size--;
                  self.removeUserDoc();
                  if (size == 0) {
                    self.removeUserDoc();
                  };
                }); 
              }); 
            } else {
              self.removeUserDoc();
            };        
          }).catch(function(error) {
          });*/
        // };
      },
      signInAnonymously(){
        var self = this;
        firebase.auth().signInAnonymously().then(function(){
          self.$router.push({name: 'profile'});
        });
      },
      fakeUserLogin(type){
        var self = this;
        self.form.email = 'fakeuser@mail.ru'; 
        self.form.password = '123456'; 
        if (type == 'expressPreview') {
          self.login('form', {
            name: 'Import items', 
            params: {
              method: 'setPowerCraftSettings',
            },
          });
        } else {
          self.login('form', {
            name: 'profile',
          });
        }; 
      }, 
    },
  };
</script>